import TextInput from "./TextInput";
import { phoneMask } from "../../utils/masks";

function PhoneInput({...props}) {
    return (
        <TextInput  mask={phoneMask} {...props} />
    );
}

export default PhoneInput;